import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LayoutModule } from '@angular/cdk/layout';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SharedModule } from '@app/shared';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { CardEdtechComponent } from './components/card-edtech/card-edtech.component';
import { CardEducationalLevelComponent } from './components/card-educational-level/card-educational-level.component';
import { CardLocationComponent } from './components/card-location/card-location.component';
import { CardNetworkProjectsComponent } from './components/card-network-projects/card-network-projects.component';
import { CardSchoolDetailComponent } from './components/card-school-detail/card-school-detail.component';
import { CardStatisticBackgroundImageComponent } from './components/card-statistic-background-image/card-statistic-background-image.component';
import { CardStatisticComponent } from './components/card-statistic/card-statistic.component';
import { CardStayTunedComponent } from './components/card-stay-tuned/card-stay-tuned.component';
import { CardStructureComponent } from './components/card-structure/card-structure.component';
import { CardStudentComponent } from './components/card-student/card-student.component';
import { CardSystemComponent } from './components/card-system/card-system.component';
import { CarouselEducacionalLevelComponent } from './components/carousel-educacional-level/carousel-educacional-level.component';
import { CarouselNetworkProjectsComponent } from './components/carousel-network-projects/carousel-network-projects.component';
import { CarouselStayStunedComponent } from './components/carousel-stay-stuned/carousel-stay-stuned.component';
import { CarouselStructureComponent } from './components/carousel-structure/carousel-structure.component';
import { CarouselSummaryStructureComponent } from './components/carousel-summary-structure/carousel-summary-structure.component';
import { DialogSchedulingOnlineComponent } from './components/dialog-scheduling-online/dialog-scheduling-online.component';
import { DialogSchedulingWhatsappComponent } from './components/dialog-scheduling-whatsapp/dialog-scheduling-whatsapp.component';
import { FerrisWheelEducacionalLevelComponent } from './components/ferris-wheel-educacional-level/ferris-wheel-educacional-level.component';
import { PostNetworkProjectsComponent } from './components/post-network-projects/post-network-projects.component';
import { PostStayStunedComponent } from './components/post-stay-stuned/post-stay-stuned.component';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './pages/home/home.component';
@NgModule({
  declarations: [
    HomeComponent,
    CardStatisticComponent,
    CardStatisticBackgroundImageComponent,
    CardSchoolDetailComponent,
    CardEducationalLevelComponent,
    CardStructureComponent,
    CardStayTunedComponent,
    CardStudentComponent,
    CardEdtechComponent,
    CardSystemComponent,
    CardNetworkProjectsComponent,
    CardLocationComponent,
    DialogSchedulingOnlineComponent,
    DialogSchedulingWhatsappComponent,
    CarouselEducacionalLevelComponent,
    FerrisWheelEducacionalLevelComponent,
    CarouselSummaryStructureComponent,
    CarouselStructureComponent,
    CarouselStayStunedComponent,
    PostStayStunedComponent,
    PostNetworkProjectsComponent,
    CarouselNetworkProjectsComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    CarouselModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    HomeRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    LayoutModule,
  ],
  exports: [CardSchoolDetailComponent, DialogSchedulingOnlineComponent, DialogSchedulingWhatsappComponent],
})
export class HomeModule {}
